module.exports = __webpack_public_path__ + "static/media/eagle.35db3c16.svg";